import React from "react";
import "./MetricCard.css";

export default function MetricCard({ icon, label, value, unit, lastUpdate }) {
  const formattedLast = lastUpdate
    ? new Date(lastUpdate).toLocaleString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      })
    : "";

  return (
    <div className="kentyou-metric-card">
      <div style={{ display: "flex", alignItems: "center" }}>
        <span className="kentyou-metric-icon">{icon}</span>
        <span className="kentyou-metric-value">
          {value !== null && value !== undefined ? value : "—"}
          {unit && <span className="kentyou-metric-unit">{unit}</span>}
        </span>
      </div>
      <div className="kentyou-metric-label">{label}</div>
      {formattedLast && (
        <div className="kentyou-metric-last">Last update: {formattedLast}</div>
      )}
    </div>
  );
}
